import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { Tag } from '@/types/tag';
import ajax from '@/utils/ajax';

const basePath = '/api/kustomer/tags';

const KustomerTagRepository = () => {
  const { host } = useContext(AppContext);

  return {
    // KustomerTags are created only through sync; this endpoint is unpaginated
    // and returns the full set of tags available to associate.
    async list(search?: string): Promise<Tag[]> {
      const response = await ajax.get({
        url: `${host}${basePath}/`,
        params: search ? { search } : undefined
      });
      return response.data as Tag[];
    }
  };
};

export default KustomerTagRepository;
